import * as React from 'react';

export default class BlankPage extends React.Component<any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
      <div className="blank-page-container">
        <div className="page"></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/PageTypes/BlankPage.tsx